<template>
  <div>
    <!--xlsx表格导出-->
    <!-- <xlsx class="addbut"></xlsx> -->
    <!-- <p class="tabletitle"></p> -->
    <el-table
      :data="list"
      border
      size="mini"
      height="650"
      id="out-table"
      :header-cell-style="{background:'#e4f1ff'}"
    >
      <el-table-column type="selection" width="35" reserve-selection :selectable="checkboxInit"></el-table-column>
      <el-table-column label="告警ID">
        <template slot-scope="scope">
          <span>{{ scope.row.device_sn }}</span>
        </template>
      </el-table-column>
      <el-table-column label="设备名称">
        <template slot-scope="scope">
          <span>{{ scope.row.device_name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="信息内容">
        <template slot-scope="scope">
          <span>{{ scope.row.device_software_ver }}</span>
        </template>
      </el-table-column>
      <el-table-column label="告警状态">
        <template slot-scope="scope">
          <span>{{ scope.row.device_deletetime }}</span>
        </template>
      </el-table-column>
      <el-table-column label="恢复状态">
        <template slot-scope="scope">
          <span>{{ scope.row.device_deletetime }}</span>
        </template>
      </el-table-column>
      <el-table-column label="时间">
        <template slot-scope="scope">
          <span>{{ scope.row.device_deletetime }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="primary" icon="icon-ziyuanxhdpi" circle></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <!--分页组件-->
    <pagination
      :total="total"
      :offset="offset"
      :limit="limit"
      @SizeChanges="SizeChanges"
      @CurrentChanges="CurrentChanges"
    ></pagination>
  </div>
</template>

<script>
import pagination from "@/components/pagination";
import { getHistoryAlarmList } from "@/api/historywarn";
import xlsx from "@/components/xlsx";

export default {
  data() {
    return {
      list: [],
      //分页组件参数
      total: 0,
      offset: 1,
      limit: 10,
      options: [
        {
          value: "选项1",
          label: "黄金糕"
        },
        {
          value: "选项2",
          label: "双皮奶"
        },
        {
          value: "选项3",
          label: "蚵仔煎"
        },
        {
          value: "选项4",
          label: "龙须面"
        },
        {
          value: "选项5",
          label: "北京烤鸭"
        }
      ],
      value: "",
      input: ""
    };
  },
  components: {
    pagination,
    xlsx
  },
  mounted() {
    getHistoryAlarmList(6).then(res => {
      this.list = res.data.data.list;
    });
  },
  //分页组件
  SizeChanges(val) {
    console.log(val);
  },
  CurrentChanges(val) {
    console.log(val);
  },
  //搜索框禁止选中
  checkboxInit(row, index) {
    if (index == 0) {
      return 0;
    } else {
      return 1;
    }
  }
};
</script>

<style scoped>
.concen {
  text-align: center;
  margin: 1rem auto;
}

.select {
  margin: 0.2rem;
}

.seekright {
  float: right;
}

.rightinput {
  width: 3rem;
  margin: 0.2rem;
}

.tabletitle {
  width: 100%;
  height: 0.8rem;
  font-size: 0.25rem;
  line-height: 0.8rem;
  background-color: #4284da;
  color: #ffffff;
  text-indent: 0.5rem;
}

.addbut {
  margin: 0.2rem 0.2rem 0.2rem 0rem;
}
</style>
